import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

const UPDATE_EVENT_V3 = gql`
  mutation UpdateEventV3($input: UpdateEventV3Input!) {
    updateEventV3(input: $input) {
      id
      name
      status
    }
  }
`;

export function useUpdateEventV3() {
  const [updateEventV3, { loading, error }] = useMutation(UPDATE_EVENT_V3);

  return {
    updateEventV3,
    saving: loading,
    saveError: error,
  };
}
